module.exports = function() {
    // global functionality goes here

    const $body = $('body'),
        $header = $('header.masthead');

    $body.addClass('jsenabled');


    // check if browser is IE - if true, add body class
    const isIE = navigator.appName === 'Microsoft Internet Explorer' ||
        !!(navigator.userAgent.match(/Trident/) ||
        navigator.userAgent.match(/rv:11/)) ||
        (typeof $.browser !== "undefined" && $.browser.msie === 1);

    if (isIE) {
        $body.addClass('browser-ie');
    }


    // push gtm-event data-values on anchors to datalayer
    $body.on( 'click', '[data-gtm-event]', function() {
        let gtm_event = $(this).data('gtm-event');
        let page_url = $(location).attr('href');

        // console.log({'dbk_category' : 'click_event', 'dbk_event' : gtm_event, 'dbk_url' : page_url }); // development

        if ( typeof dataLayer !== 'undefined' ) {
            dataLayer.push({'dbk_category': 'click_event', 'dbk_event': gtm_event, 'dbk_url': page_url}); // production
        }
    });


    // prevent disabled buttons to execute default actions
    $('.btn-disabled').click( function(e) {
        e.preventDefault();
    });


    // unfocus links after click
    $body.on('click', 'a, button', function () {
        $(this).blur();
    });


    // init lightbox
    $('a.lightbox').nivoLightbox({
        afterShowLightbox: function(){
            let $iframe = $('.nivo-lightbox-content > iframe'),
                src = $iframe.attr('src');

            $iframe.attr('src', src + '?autoplay=1&rel=0&disablekb=1&fs=0');
        }
    });


    // init tooltips
    $body.tooltip({
        selector: '[data-toggle="tooltip"]',
        container: 'body'
    });

    // init popovers
    $body.popover({
        selector: '[data-toggle="popover"]',
        trigger: 'click',
        html: true,
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    });

    // close open popovers on click outside popover
    $(document).on('click', function(e) {
        if ( ! $(e.target).closest('.popover').length > 0 && !$(e.target).is('[data-toggle="popover"]') ) {
            $('[data-toggle="popover"]').popover('hide');
        }
    });

    // reset click state for above hidden popovers
    $body.on('hidden.bs.popover', function (e) {
        let popoverData = $(e.target).data('bs.popover');

        if (popoverData) {
            popoverData.inState.click = false;
        }
    });


    // toggle-menu
    $('#toggle-menu').click( function(e) {
        e.preventDefault();

        if ( $body.hasClass('show-menu') ) {
            $body.removeClass('show-menu');
        } else {
            $body.addClass('show-menu');
        }
    });
    // close menu
    $('#close-mobile-nav').click( function(e) {
        e.preventDefault();

        if ( $body.hasClass('show-menu') ) {
            $body.removeClass('show-menu');
        }
    });


    // when a link is clicked with href attribute starting with #, scroll that shit smoothly (if target exists)
    $body.on('click', 'a[href^="#"]', function() {
        let $this = $(this);
        let target = $(this).attr('href');
        let scrollOffset = $header.outerHeight();

        // check if target is more than just a # dummy link
        if (target.length > 1) {

            // check if target is a complete url instead of only #id, if so, extract ID part
            if (!target.startsWith('#')) {
                target = '#'+ target.split('#').pop();
            }

            if ($this.data('extra-scroll-offset')) {
                 scrollOffset = scrollOffset + $(this).data('extra-scroll-offset');
            }

            // if target exists
            if ( $(target).length > 0 ) {

                // if target has top margin, add half of it to scroll offset
                let targetMargin = parseInt($(target).css('marginTop'));

                if (targetMargin > 0) {
                    scrollOffset = scrollOffset + (targetMargin / 2);
                }

                $('html, body').stop().animate({
                    scrollTop: $(target).offset().top - scrollOffset
                }, 1000, 'easeInOutCubic', function() {
                    $this.blur();
                });
            }
        }
    });


    // disable hero-video with URL variable
    if ( window.location.search.indexOf('no_video=1') >= 0 ) {
        $('section.hero .hero__background-video').hide();
    }


    // insert check icon elements to ul.list-checked in content-wrapper
    $('.content-wrapper .list-checked > li').each( function() {
        $(this).prepend('<i class="item-icon far fa-check"></i>');
    });


    // load extra JS parts
    require('./forms');
    require('./sticky-header');
    require('./parallax-background');
    require('./sliders');
    require('./tabs');
    require('./expandable-items');
    require('./pricing');
    require('./modals');
    require('./wizard');

};